var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDirections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.623,
    height: 15.623,
    viewBox: "0 0 15.623 15.623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-directions",
    "data-name": "Icon awesome-directions",
    d: "M15.337,7.12,8.5.287a.979.979,0,0,0-1.384,0L.287,7.12a.979.979,0,0,0,0,1.384L7.12,15.337a.978.978,0,0,0,1.384,0L15.337,8.5a.979.979,0,0,0,0-1.384ZM12.255,7.5,9.686,9.875a.244.244,0,0,1-.41-.179V8.056H6.347v1.953a.244.244,0,0,1-.244.244H5.126a.244.244,0,0,1-.244-.244V7.568a.977.977,0,0,1,.976-.976H9.276V4.952a.244.244,0,0,1,.41-.179l2.57,2.372a.244.244,0,0,1,0,.359Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDirections);
export default __webpack_public_path__ + "static/media/icon-directions.ee6fd6b25339ac082295bc69050cea89.svg";
export { ForwardRef as ReactComponent };